

type HeroBoxComponentProps = {
    icon: string;
    position: "right" | "left";
    text: string;
    backgroundColor: string;
    iconBackgroundColor: string
}



export default function HeroBoxComponent({ 
    icon,
    position,
    text,
    backgroundColor,
    iconBackgroundColor
} : Readonly<HeroBoxComponentProps>) {



  return (
    <div className={`hero-box hero-box-${position} bg-${backgroundColor}`}>
        {
            position === "left" &&  <i className={`${icon} hero-box-icon hero-box-icon-${position} bg-${iconBackgroundColor}`}></i>
        }
        
        <p className="text">
            {text}
        </p>

        {
            position === "right" &&  <i className={`${icon} hero-box-icon hero-box-icon-${position} bg-${iconBackgroundColor}`}></i>
        }
       
    </div>
  )
}